// extracted by mini-css-extract-plugin
module.exports = {"association":"SectionAssociation_association__a8_sM","container":"SectionAssociation_container__dhEdk","association__paragraph":"SectionAssociation_association__paragraph__YKK9f"};